import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const wcuSection = document.querySelectorAll('.why-choose-us-section');

    wcuSection.forEach((section) => {
        const slider = section.querySelector('.wcus-slider');

        if ( slider ) {
            new Swiper(slider, {
                slidesPerView: 1,
                loop: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                allowTouchMove: false,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: slider.parentNode.querySelector('.wcus-pagination'),
                    type: 'fraction',
    
                    formatFractionCurrent: function(number) {
                        return String(number).padStart(2, '0');
                    },
    
                    formatFractionTotal: function(number) {
                        return String(number).padStart(2, '0');
                    },
    
                    renderFraction: function(currentClass, totalClass) {
                        return `
                <span class="${currentClass}"></span>
                /
                <span class="${totalClass}"></span>
            `;
                    },
                },
                navigation: {
                    nextEl: slider.parentNode.querySelector('.wcus-button-next'),
                    prevEl: slider.parentNode.querySelector('.wcus-button-prev'),
                },
            });
        }
    });
});
